import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { useApplicationState } from '@atlas/core';
import { Icon, Label, MoneyInput } from '@atlas/ui';

const LimitInput = ({ field, onChange, required, ...props }) => {
  const { error, errorMessage, formRef, name, value, warning, ...fieldProps } = field;
  const { wallet } = useApplicationState();

  const handleBlur = useCallback(() => {
    formRef.current.blurField(field.name);
  }, [field.name, formRef]);

  const handleChange = useCallback(
    newValue => {
      onChange(newValue, true);
      if (formRef.current) {
        // Immediately set the field as touched
        formRef.current.touchedFields[field.name] = true;
      }
    },
    [field.name, formRef, onChange],
  );

  return (
    <div className="profile-limit__input-wrapper">
      {required ? (
        <div className="limit__input__required">
          <Label
            className="profile-limit__input-label"
            message={`responsible_game_${name}_limit`}
          />{' '}
          <span className="limit__input__mark">*</span>
        </div>
      ) : (
        <Label className="profile-limit__input-label" message={`responsible_game_${name}_limit`} />
      )}

      {warning && (
        <span className="profile-limit__warning-message">
          <Icon name="warning" />
          <Label {...warning} />
        </span>
      )}

      <MoneyInput
        currency={wallet.currency}
        label="amount"
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        {...fieldProps}
        {...props}
      />

      {error && !required && (
        <div className="profile-limit__error-block">
          <Icon className="profile-limit__error-icon" height={24} name="icon-error" width={24} />
          <div className="profile-limit__error-text">
            <Label className="profile-limit__error-text-title" message="not_saved_limit_title" />
            <Label className="profile-limit__error-text-message" message={errorMessage} />
          </div>
        </div>
      )}
    </div>
  );
};

LimitInput.propTypes = {
  field: PropTypes.shape({
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    formRef: PropTypes.object,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    warning: PropTypes.string,
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

export default LimitInput;
